module.exports = __webpack_public_path__ + "static/media/slet.2480b51e.svg";